import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { LanguageProvider } from '@/contexts/LanguageContext';
import LandingPage from '@/pages/LandingPage';
import AdminPage from '@/pages/Admin';
import BookACallPage from '@/pages/BookACallPage';
import FsePage from '@/pages/FsePage';
import BrochurePage from '@/pages/BrochurePage';
import AboutPage from '@/pages/AboutPage';
import WhyPage from '@/pages/WhyPage';
import TargetPage from '@/pages/TargetPage';
import ContactPage from '@/pages/ContactPage';
import FaqPage from '@/pages/FaqPage';
import EventiPage from '@/pages/EventiPage';
import { ReaderAuthProvider } from '@/contexts/ReaderAuthContext';
import PublicLayout from '@/pages/extra/PublicLayout';
import ExtraLibraryPage from '@/pages/extra/ExtraLibraryPage';
import ExtraBookPage from '@/pages/extra/ExtraBookPage';
import ReaderLoginPage from '@/pages/extra/ReaderLoginPage';
import ReaderRegisterPage from '@/pages/extra/ReaderRegisterPage';
import ReaderForgotPasswordPage from '@/pages/extra/ReaderForgotPasswordPage';
import ReaderResetPasswordPage from '@/pages/extra/ReaderResetPasswordPage';
import { Toaster } from 'sonner';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {/* Home */}
            <Route path="/" element={<LandingPage />} />

            {/* Marketing standalone pages (IT slugs, SEO-friendly) */}
            <Route path="/chi-siamo" element={<AboutPage />} />
            <Route path="/perche-sceglierci" element={<WhyPage />} />
            <Route path="/a-chi-ci-rivolgiamo" element={<TargetPage />} />
            <Route path="/contatti" element={<ContactPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/eventi" element={<EventiPage />} />

            {/* Vetrina libri · Contenuti Extra (replica 1:1 prime-crm-hub-1) */}
            <Route element={<ReaderAuthProvider><PublicLayout /></ReaderAuthProvider>}>
              <Route path="/extra" element={<ExtraLibraryPage />} />
              <Route path="/extra/:bookId" element={<ExtraBookPage />} />
              <Route path="/reader/login" element={<ReaderLoginPage />} />
              <Route path="/reader/register" element={<ReaderRegisterPage />} />
              <Route path="/reader/forgot" element={<ReaderForgotPasswordPage />} />
              <Route path="/reader/reset" element={<ReaderResetPasswordPage />} />
            </Route>

            {/* Lead-gen / conversion routes */}
            <Route path="/bookacall" element={<BookACallPage />} />
            <Route path="/book-a-call" element={<BookACallPage />} />
            <Route path="/demo" element={<BookACallPage />} />
            <Route path="/prenota-demo" element={<BookACallPage />} />
            <Route path="/fse" element={<FsePage />} />
            <Route path="/brochure" element={<BrochurePage />} />

            {/* Admin */}
            <Route path="/admin" element={<AdminPage />} />

            {/* Fallback → home */}
            <Route path="*" element={<LandingPage />} />
          </Routes>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: 'rgba(255,255,255,0.95)',
                border: '1px solid rgba(27,127,184,0.20)',
                color: '#0B1220',
                backdropFilter: 'blur(16px)',
                boxShadow: '0 20px 40px -20px rgba(15,23,42,0.20)',
              },
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
